const carSearchInput = (tripId, selectedTab, isTripSearch) => (store) => {
  if (isTripSearch) {
    return {
      searchInputs: store.tripSearch.searchInputs.car,
      searchObj: store.tripSearch.searchObj.car,
      defaultSearchObj: store.tripSearch.searchObj.car.defaultSearchObj || {},
      responseFilters: store.tripSearch.searchObj.car.responseFilters || {},
    };
  }

  const carTab = store.car.carSearches[tripId].carTabs[selectedTab] || {};
  const { sortBy, sortDirection } = store.tripSearch.searchObj.car;
  const { searchObj, searchStatus } = carTab;
  return {
    searchStatus,
    searchObj: { ...searchObj, sortBy, sortDirection },
    searchInputs: searchObj,
    responseFilters: carTab,
    defaultSearchObj: store.car.carSearches[tripId].defaultSearchObj,
  };
};
export default carSearchInput;
